<template>
  <div>
    <template v-if="!$isMobile()">
      <template v-if="height > 0">
        <el-table :data="tableData" :max-height="height" @row-click="rowClick" :emptyText="$t('messages.lblEmptyText')">
          <template v-for="(item, index) in tableHeader">
            <el-table-column
              v-if="item.columnType === 'custom'"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :min-width="item.width"
              :type="item.type"
              :align="item.align"
            >
              <template slot-scope="scope">
                <slot :name="item.prop" v-bind:scope="scope"></slot>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :min-width="item.width"
              :type="item.type"
              :align="item.align"
            />
          </template>
        </el-table>
      </template>
      <template v-else>
        <el-table :data="tableData" @row-click="rowClick" :emptyText="$t('messages.lblEmptyText')">
          <template v-for="(item, index) in tableHeader">
            <el-table-column
              v-if="item.columnType === 'custom'"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :min-width="item.width"
              :type="item.type"
              :align="item.align"
            >
              <template slot-scope="scope">
                <slot :name="item.prop" v-bind:scope="scope"></slot>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :min-width="item.width"
              :type="item.type"
              :align="item.align"
            />
          </template>
        </el-table>
      </template>
    </template>
    <div v-if="$isMobile()">
      <ul>
        <li class="ly-table-box" v-for="(items, idx) in tableData" :key="idx">
          <div class="table-box">
            <ul>
              <li
                class="table-box-content"
                v-for="(item, index) in tableHeader"
                :key="index"
              >
                <div class="title">
                  <div>{{ item.label }}</div>
                </div>
                <div class="content">
                  <span v-if="Object.keys(items)[index] === item.prop">{{
                    items[item.prop]
                  }}</span>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tableHeader: {
      type: Array,
      default: () => [],
    },
    Static: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    rowClick(row, col) {
      this.clickRow = row.col1;
      this.$emit("clickRow", col, row);
    },
  },
};
</script>

<style lang="scss" scoped>
// 2022.03.25 스크롤 수정
.el-table {
  &__body-wrapper {
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      &-thumb {
        width: 3px;
        height: 3px;
        background-color: $--text-disabled;
        border-radius: $--border-radius-base;
      }
    }
  }
}
.ly-table-box {
  display: block;
  .table-box {
    border-top: 1px solid $--border-color-gray;
    &-content {
      .title {
        padding: 10px;
        background: $--color-white-smoke;
        span {
          font-size: $--font-size-small;
          color: $--color-black;
        }
      }
      .content {
        padding: 10px;
        border: 0 {
          top: 1px solid $--border-color-gray;
          bottom: 1px solid $--border-color-gray;
        }
      }
    }
  }
}
</style>
